(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefit-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Make sure the marquee always has enough content to scroll smoothly.
  // If there are too few blocks, we can duplicate the "track" via cloning the group until it's wide enough.
  const sectionEl = document.currentScript.closest('.section-benefit-bar');
  if (!sectionEl) return;

  const marquee = sectionEl.querySelector('.benefit-bar__marquee');
  const track = sectionEl.querySelector('.benefit-bar__track');
  if (!marquee || !track) return;

  // The template renders two groups by default. If still not wide enough, clone more.
  const ensureFill = () => {
    const viewportW = marquee.getBoundingClientRect().width;
    const trackW = track.scrollWidth;

    // We want at least 2x viewport width so the -50% loop looks continuous.
    if (trackW >= viewportW * 2) return;

    const groups = track.querySelectorAll('.bb-items');
    if (groups.length === 0) return;

    // Clone the last group until wide enough (cap to avoid runaway).
    let safety = 0;
    while (track.scrollWidth < viewportW * 2 && safety < 10) {
      track.appendChild(groups[0].cloneNode(true));
      safety++;
    }
  };

  ensureFill();
  window.addEventListener('resize', ensureFill, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
